<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      d="M19.14 10.29a2 2 0 010 3.43L7.03 20.98A2 2 0 014 19.27V4.73a2 2 0 013.03-1.71z"
      fill="currentColor"
    />
  </g>
</template>
